/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Schedule_With_ProviderInputs */

const en_vault_schedule_with_provider = /** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the link above to schedule your session with the provider.`)
};

const es_vault_schedule_with_provider = /** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa el enlace de arriba para programar tu sesión con el proveedor.`)
};

const fr_vault_schedule_with_provider = /** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez le lien ci-dessus pour planifier votre session avec le prestataire.`)
};

const de_vault_schedule_with_provider = /** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende den obigen Link, um deine Sitzung mit dem Anbieter zu planen.`)
};

const id_vault_schedule_with_provider = /** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan tautan di atas untuk menjadwalkan sesi Anda dengan penyedia.`)
};

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const ja_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const zh_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const ar_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const it_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const ru_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const pt_vault_schedule_with_provider = en_vault_schedule_with_provider;

/** @type {(inputs: Vault_Schedule_With_ProviderInputs) => LocalizedString} */
const ko_vault_schedule_with_provider = en_vault_schedule_with_provider;

/**
* | output |
* | --- |
* | "Use the link above to schedule your session with the provider." |
*
* @param {Vault_Schedule_With_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_schedule_with_provider = /** @type {((inputs?: Vault_Schedule_With_ProviderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Schedule_With_ProviderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_schedule_with_provider(inputs)
	if (locale === "es") return es_vault_schedule_with_provider(inputs)
	if (locale === "fr") return fr_vault_schedule_with_provider(inputs)
	if (locale === "de") return de_vault_schedule_with_provider(inputs)
	if (locale === "ja") return ja_vault_schedule_with_provider(inputs)
	if (locale === "zh") return zh_vault_schedule_with_provider(inputs)
	if (locale === "ar") return ar_vault_schedule_with_provider(inputs)
	if (locale === "id") return id_vault_schedule_with_provider(inputs)
	if (locale === "it") return it_vault_schedule_with_provider(inputs)
	if (locale === "ru") return ru_vault_schedule_with_provider(inputs)
	if (locale === "pt") return pt_vault_schedule_with_provider(inputs)
	return ko_vault_schedule_with_provider(inputs)
});